import { useNavigate } from 'react-router-dom';
import { latestUpdates } from '@/mocks/videoData';

export default function LatestUpdates() {
  const navigate = useNavigate();

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-1">
              最新更新
            </h2>
            <p className="text-sm text-foreground-600">每日更新，追剧不等待</p>
          </div>
          <a
            href="/category/tv"
            onClick={(e) => { e.preventDefault(); navigate('/category/tv'); }}
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 cursor-pointer whitespace-nowrap"
          >
            查看更多
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {latestUpdates.map((item) => (
            <a
              key={item.id}
              href={`/article/${item.slug}`}
              onClick={(e) => { e.preventDefault(); navigate(`/article/${item.slug}`); }}
              className="group flex gap-3 p-3 bg-background-100 hover:bg-background-200 rounded-lg cursor-pointer transition-colors"
            >
              <div className="w-20 h-28 flex-shrink-0 rounded-md overflow-hidden bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="flex flex-col justify-between py-1 min-w-0">
                <div>
                  <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1">{item.category}</p>
                </div>
                <span className="inline-block text-xs px-2 py-0.5 bg-accent-100 text-accent-700 rounded whitespace-nowrap">
                  {item.updateInfo}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}